import cashierAuditing from './cashierAuditing'
import settlementVerification from './settlementVerification'
import reconciliation from './reconciliation'
import cashJournal from './cashJournal'
import financialReady from './financialReady'
import financialAccounting from './financialAccounting'
import report from './report'
import reimbursementResult from './reimbursementResult' // 请款结果

// 定制逻辑处理
export default {
  ...cashierAuditing,
  ...settlementVerification,
  ...reconciliation,
  ...cashJournal,
  ...financialReady,
  ...financialAccounting,
  ...report,
  ...reimbursementResult
}
